import React from "react";

import "./TextPage.css";

export const TextPage: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="text-page">{children}</div>;
